<template>
  <el-row class="step-content">
    <el-col :span="2" :xs="6">
      <span class="step-number">{{ num + 1 }}</span>
    </el-col>
    <el-col :span="20" :xs="12">
      <h4 class="step-title">{{ step.title }}</h4>
      <span class="step-description">{{ step.description }}</span>
    </el-col>
    <el-col :span="2" :xs="6">
      <el-tag type="success" size="small">
        <el-icon>
          <CheckElementIcon />
        </el-icon>
        {{ tag }}
      </el-tag>
    </el-col>
  </el-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    step: {
      type: Object,
      required: true,
      default: () => ({
        href: '',
        title: '',
        description: ''
      })
    },
    num: {
      type: Number,
      default: 0
    },
    tag: {
      type: String,
      default: ''
    }
  }
})
</script>
<style lang="scss" scoped></style>
